// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"d492752e","549":"e87b0e38","640":"e7d23d64","846":"877d0582"}[chunkId] + ".chunk.css";
};